// extracted by mini-css-extract-plugin
module.exports = {"container":"settingsMobileOverlay__container___dhpgN","title":"settingsMobileOverlay__title___3smB8"};